import { combineReducers } from 'redux';
import tabReducer from './tabReducer';
import infoReducer from './infoReducer';
import selectionReducer from './selectionReducer';
import dataReducer from './dataReducer';
import configReducer from './configReducer';
import pendingReducer from './pendingReducer';
import pxqReducer from './pxqReducer';
import errorReducer from './errorReducer';
import columnReducer from './columnReducer';

export default combineReducers({
    metadata: tabReducer,
    info: infoReducer,
    selection: selectionReducer,
    data: dataReducer,
    config: configReducer,
    pending: pendingReducer,
    pxqUrl: pxqReducer,
    error: errorReducer,
    column: columnReducer
})
